import React, { useEffect, useState } from "react";
import CommonInputField from "../components/BrandsPartnerComponents/common_input_field";
import SingleSelectButtonGroupWithOther from "../components/BrandsPartnerComponents/single_select_button_group_with_other";
import MarketPlaceIcon from "../components/BrandsPartnerComponents/MarketplaceIcon";
import MultipleInputComponent from "../components/BrandsPartnerComponents/MultipleInputComponent";
import AddNewItemWithUrl from "../components/BrandsPartnerComponents/AddNewItemWithUrl";
import MobileSocialLinksList from "../components/BrandsPartnerComponents/mobile_social_links";
import { BrandsType } from "./dtos/brands.dtos";
import NavigationButton from "../components/BrandsPartnerComponents/navigation_button";
import { useBrandsOnboarding } from "../../contexts/BrandsOnboardingContext";
import LinkedinIcon from "../../components/icons/LinkedinIcon";
import FacebookIcon from "../../components/icons/FacebookIcon";
import InstagramIcon from "../components/BrandsPartnerComponents/InstagramIcon";
import { marketplacesOptions } from "../../constants/dataConstants";

type Props = {
  data: BrandsType;
  setData: React.Dispatch<React.SetStateAction<BrandsType>>;
  previousStep: () => void;
  nextStep: () => void;
  isMobile?: boolean;
};
const socialPlatforms = [
  { label: "LinkedIn", value: "linkedin", icon: <LinkedinIcon /> },
  { label: "Facebook", value: "facebook", icon: <FacebookIcon /> },
  { label: "Instagram", value: "instagram", icon: <InstagramIcon /> },
];
const BrandOwnershipPage: React.FC<Props> = ({
  data,
  setData, previousStep, nextStep, isMobile
}) => {
  const options = [
    { value: 0, label: "0-1 years" },
    { value: 1, label: "1-2 years" },
    { value: 2, label: "2-5 years" },
    { value: 3, label: "5+ years" },
  ];
  const { customOptionsMap, setCustomOptionsMap } = useBrandsOnboarding();

 
  const [links, setLinks] = useState<
    { platform: string; url: string; icon: React.ReactNode }[]
  >([]);
  const [marketplace, setMarketplace] = useState<
    { platform: string; url: string; icon: React.ReactNode }[]
  >([]);




  // const [selected, setSelected] = useState<number | string>('');
  const [open, setOpen] = useState(false);
  const [openMarketplace, setOpenMarketplace] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [isNewMarketPlace, setIsNewMarketPlace] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState<{ platform: string; url: string; icon: React.ReactNode }>({ platform: "", url: "", icon: undefined });
  const [selectedMarketPlace, setSelectedMarketPlace] = useState<{ platform: string; url: string; icon: React.ReactNode }>({ platform: "", url: "", icon: undefined });
  const [errors, setErrors] = useState({
    brand_name: '',
    years_of_operation: '',
    current_revenue: '',
  });

  const handleSetLinks = (newLinks: typeof links) => {

    setData((prev) => ({
      ...prev,
      digitalPresence: {
        ...prev.digitalPresence!,
        social_media: newLinks.map((link) => ({
          platform: link.platform,
          url: link.url,
          number_of_followers: 0, // or handle this properly if input exists
        })),
      },
    }));
  };

  const handleSetMarketplace = (newMarketplaces: typeof marketplace) => {
    setMarketplace(newMarketplaces);
    setData((prev) => ({
      ...prev,
      digitalPresence: {
        ...prev.digitalPresence!,
        market_place: newMarketplaces.map((market) => ({
          platform: market.platform,
          url: market.url,
          store_rating: 0, // or handle properly
        })),
      },
    }));
  };


  const showDrawer = (isNew: boolean, platform?: { platform: string; url: string; icon: React.ReactNode }) => {
    setOpen(true);
    setIsNew(isNew);
    if (!isNew) {
      setSelectedPlatform(platform!);
    }
  };
  const showDrawerMarketPlace = (isNew: boolean, platform?: { platform: string; url: string; icon: React.ReactNode }) => {
    setOpenMarketplace(true);
    setIsNewMarketPlace(isNew);
    if (!isNew) {
      setSelectedMarketPlace(platform!);
    }
  };

  const onClose = () => {
    setOpen(false);
  };
  const onCloseMarketplace = () => {
    setOpenMarketplace(false);
  };

  //setlinks
  useEffect(() => {
    const socialLinks = data.digitalPresence?.social_media?.map((item) => ({
      platform: item.platform,
      url: item.url,
      icon:
        socialPlatforms.find(
          (sp) => sp.label.toLowerCase() === item.platform.toLowerCase()
        )?.icon || null,
    })) || [];
  
    setLinks(socialLinks);
  }, [data.digitalPresence]); // ✅ Safe dependency
  
  //setmarketplace
  useEffect(() => {
    const mappedMarketplaces = data.digitalPresence?.market_place?.map((item) => ({
      platform: item.platform,
      url: item.url,
      icon: <MarketPlaceIcon />, // You can customize if needed
    })) || [];
  
    setMarketplace(mappedMarketplaces);
  }, [data.digitalPresence]); // ✅ Safe dependency
  
  const handleNext = () => {
    let hasError = false;
    const newErrors = {
      brand_name: '',
      years_of_operation: '',
      current_revenue: '',
    };

    if (!data.brand_name.trim()) {
      newErrors.brand_name = 'Brand you own is required.';
      hasError = true;
    }

    if (!data.years_of_operation.trim()) {
      newErrors.years_of_operation = 'Years of operation is required.';
      hasError = true;
    }

    if (!data.current_revenue.trim()) {
      newErrors.current_revenue = 'Current revenue status is required.';
      hasError = true;
    }

    setErrors(newErrors);

    if (!hasError) {
      nextStep();
    }
  };

  return (
    <div className="w-full max-w-[686px]">
      <div className="common-title pb-[12px]">Brand Ownership & Experience</div>
      <div className="common-sub-text pb-[60px]">We’d love to know about your brands! This helps us understand your business landscape better.</div>

      {/*Form */}
      <div className="flex flex-col gap-y-[32px]">

        {/* Brand You Own */}
        <div className="col-span-1">
          <CommonInputField
            label="Brand You Own"
            // placeholder="Nexture"
            value={data.brand_name}
            // onChange={(e) => setBrandValue(e.target.value)}
            onChange={(e) => {
              const value = e.target.value;
              setData((current) => ({ ...current, brand_name: value }));
          
              if (value.trim()) {
                setErrors((prev) => ({ ...prev, brand_name: '' }));
              }
            }}
          />
          {errors.brand_name && (
            <p className="text-red-500 text-sm mt-1">{errors.brand_name}</p>
          )}

        </div>

        {/* Years of Operation*/}
        <div>
        <SingleSelectButtonGroupWithOther
  error={errors.years_of_operation}
  label="Years of Operation"
  options={options}
  selectedValue={data.years_of_operation} // assuming this is like "0-1 years"
  setSelectedValue={(label) => {
    setData((curret) => ({
      ...curret,
      years_of_operation: String(label),
    }));
    if (label) {
      setErrors((prev) => ({ ...prev, years_of_operation: '' }));
    }
  }}
/>

          {errors.years_of_operation && (
            <p className="text-red-500 text-sm mt-1">{errors.years_of_operation}</p>
          )}
        </div>

        {/* Current Revenue Status (USD) */}
        <div className="md:w-[335px]">
          <CommonInputField
            label="Current Revenue Status (USD)"
            // placeholder="500,000"
            type="number"
            prefix={"$"}
            value={data.current_revenue}
            onChange={(e) =>
              setData((curret) => ({
                ...curret,
                current_revenue: e.target.value,
              }))}
          // onChange={(e) => setRevenueStatusValue(e.target.value)}
          />
          {errors.current_revenue && (
            <p className="text-red-500 text-sm mt-1">{errors.current_revenue}</p>
          )}
        </div>

        {/* Social Media Platform Dropdown */}
        {/* mobile only */}
        {/* <div className="block md:hidden flex flex-col gap-y-4 items-start ">
                    <div className="common-title text-[#1d2939] text-base pb-[14px]">Your Social Media Presence</div>

                    {links.map((link, index) => (
                        link.platform && (
                            <div className="border border-[#F2F4F7] p-[14px] rounded-[6px] w-full" key={index}>
                                <div className="flex gap-x-[10px] items-center w-full">
                                 
                                    <div className="flex items-center justify-center p-2 bg-[#f2f4f7] rounded-[40px]">
                                        {link.icon}
                                    </div>

                                    <div className="flex flex-col gap-y-2 w-full">
                                        <div className="flex items-center justify-between w-full">
                                            <p className="text-[#344054] text-sm font-medium font-['Inter'] leading-tight m-0">
                                                {link.platform}
                                            </p>
                                            <div className="shrink-0" onClick={() => showDrawer(false,link)}>
                                                <ChevronRight />
                                            </div>
                                        </div>

                                        <p className="text-[#175cd3] text-[13px] font-normal font-['Inter'] leading-[19px] m-0">
                                            {link.url}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )
                    ))}



                    <NavigationButton
                        type="text"
                        icon={<PlusOutlined />}
                        onClick={() => showDrawer(true)}
                        label="Add New"
                    />

                </div> */}
        <MobileSocialLinksList
          title="Your Social Media Presence"
          links={links}
          showDrawer={showDrawer}
        />
        <MobileSocialLinksList
          title="Where Do You Sell?"
          links={marketplace}
          showDrawer={showDrawerMarketPlace}
        />
        <div className="hidden md:block">
          <MultipleInputComponent title="Your Social Media Presence" field="Social Media" links={links} setLinks={handleSetLinks} socialPlatforms={socialPlatforms}
          /></div>

        {/* Where Do You Sell? */}
        <div className="hidden md:block">
          <MultipleInputComponent title="Where Do You Sell?" field="Maketplace" links={marketplace} setLinks={handleSetMarketplace} socialPlatforms={marketplacesOptions}
            commonIcon={<MarketPlaceIcon />} />
        </div>


      </div>

      <AddNewItemWithUrl title="Your Social Media Presence" field="Social Media" links={links} setLinks={handleSetLinks} socialPlatforms={socialPlatforms} deleteLabel="Remove this social media"
        isNew={isNew} openDrawer={open} onClose={onClose} selectedLink={selectedPlatform} />
      <AddNewItemWithUrl title="Where Do You Sell?" field="Market Place" links={marketplace} setLinks={handleSetMarketplace} socialPlatforms={marketplacesOptions} deleteLabel="Remove this marketplace"
        isNew={isNewMarketPlace} openDrawer={openMarketplace} onClose={onCloseMarketplace} selectedLink={selectedMarketPlace} />

      {/* Desktop Next/Previous Navigation */}
      {!isMobile && (
        <div className="mt-[60px]   inline-flex flex justify-start gap-x-[8px] w-full md:w-auto">
          <NavigationButton
            onClick={previousStep}
            label="Previous"
            type="text"
          />

          <NavigationButton
            onClick={handleNext}
            label={"Next"}
            type="primary"
          />
        </div>
      )}

      {/* Mobile Bottom Navigation */}
      {isMobile && (
        <div className="fixed bottom-0 left-0 right-0 flex justify-center px-4 py-4 gap-x-2 w-full shadow-lg z-20 bg-white">
          {
            <NavigationButton
              onClick={previousStep}
              label="Previous"
              type="text"
              block
            />
          }
          <NavigationButton
            onClick={handleNext}
            label={"Next"}
            type="primary"
            block
          />
        </div>
      )}
    </div>
  );
};

export default BrandOwnershipPage;
